import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AmChartsService } from "@amcharts/amcharts3-angular";
import { GUID, Param } from "app/brightserve/brightserve.module";
import { CaseService } from "app/case/case.service";

import { Subscription } from "rxjs/Subscription";

import { Incident } from "app/shared/shared.module";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";
import { NotificationsService } from 'angular2-notifications';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'app-case-details-trends',
    templateUrl: './case-details-trends.component.html',
    styleUrls: ['./case-details-trends.component.css']
})
export class CaseDetailsTrendsComponent implements OnInit {
    @ViewChild('ReadingsModal') public ReadingsModal: ModalDirective;

    private chart: any;
    SelectedDate: Date;
    Today: Date = new Date();
    firstChartDate: Date;
    lastChartDate: any;

    data: Incident;
    observaions: any[] = [];

    dates: any[] = [];
    devices: any[] = [];
    deviceReadings: any[] = [];

    TrendsDates: any[] = [];
    TrendsData: any[] = [];
    TrendsDataTable: any[] = [];

    PeakFlowReadings: any[] = [];
    ShowPeakFlow: boolean = true;

    IncidentId: any;

    sub: Subscription;
    GettingChartData: Subscription;

    Period: number = 1;
    Offset: number = 0;
    GraphSeriesLeft = [
        { Id: "BloodPressure", Title: "Blood Pressure", Unit: "mmHg", Colour: "bg-yellow-crusta", Icon: "flaticon-sphygmomanometer" },
        { Id: "PulseRate", Title: "Pulse Rate", Unit: "BPM", Colour: "black", Icon: "flaticon-stethoscope", Selected: true },
        { Id: "PulseO2", Title: "SpO<sub>2</sub>", Unit: "%", Colour: "light-blue", Icon: "flaticon-cardiogram-1" },
    ];

    GraphSeriesRight = [
        { Id: "Temperature", Title: "Temperature", Unit: "C", Colour: "bg-red-mint", Icon: "flaticon-thermometer" },
        { Id: "RespiratoryRate", Title: "Respiratory Rate", Unit: "/min", Colour: "bg-purple-seance", Icon: "flaticon-lungs" },
        { Id: "BloodSugar", Title: "Blood Sugar", Unit: "mmol/L", Colour: "bg-blue-steel", Icon: "flaticon-sugar-blood-level" },
        { Id: "GCS", Title: "Glasgow Coma Scale", Unit: "", Colour: "bg-purple-soft", Icon: "flaticon-brain" },
    ];

    SelectedSeries = {
        "PulseRate": true,
        "RespiratoryRate": true,
        "PulseO2": true,
        "GCS": true,
        "BloodPressure": true,
        "Temperature": true,
        "BloodSugar": true
    };

    constructor(private AmCharts: AmChartsService, private caseService: CaseService, private route: ActivatedRoute, public ngZone: NgZone, private busyLoaderService: BusyLoaderService, private _notification: NotificationsService) { 
        AmCharts.useUTC= true;
    }

    DeviceUnits: any = {
        "PulseRate": "BPM",
        "RespiratoryRate": "/min",
        "PulseO2": "%",
        "Systolic": "mmHg",
        "Diastolic": "mmHg",
        "Temperature": "&#8451;",
        "Peakflow": "L/min",
        "FEV1": "L",
        "BloodSugar": "mmol/L",
        "Haematocrit": "%",
        "Ketone": "mmol/L",
        "GlasgowComaScale": "GCS",
    };
    TimeSelectors = [
        { Title: "All", Period: -1 },
        { Title: "Last 24 Hours", Period: 24 },
        { Title: "Last 12 Hours", Period: 12 },
        { Title: "Last 6 Hours", Period: 6 },
        { Title: "Last Hour", Period: 1 },
    ];
    SelectedTime: string = "Last Hour";

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.IncidentId = params['id'];
                this.init();
            };
        });
    };
    
    ngOnDestroy() {
        if (this.chart) {
            try {
                this.AmCharts.destroyChart(this.chart);
            }
            catch (ex) {
                console.error(ex);
            }
        }
        try {
            this.sub.unsubscribe();
       } catch (e) {}
        if (this.GettingChartData != null) {
            try {
            this.GettingChartData.unsubscribe();
        } catch (e) {}
        }
    }

    init() {
        //GET CHART DATA
        this.GetChartData();
    }

    GetChartData(period: number = 1, offset: number = 0) {
        this.TrendsDates = [];
        this.TrendsData = [];
        this.TrendsDataTable = [];
        this.PeakFlowReadings = [];

         this.caseService.GetObservationsForPeriod(this.IncidentId, period, offset).subscribe(

            data => {
                this.data = data;
                console.log("Trends Data: ", data);

                this.observaions = data.Observations;

                //FORMAT DATA IF NEEDED AND REMOVE PEAK FLOW READINGS
                try {
                var lastSPO2Date: Date = null;
                this.data.Observations.forEach((item) => {
                    item.ObservationDate = new Date(item.ObservationDate);
                    var itemType = item.Type.Definition;
                    if (itemType)
                        itemType = itemType.replace(/\s/g, '');

                     if (item.Type.Definition == "PeakFlow") {
                            var reading = {
                                Time: item.ObservationDate,
                                Peakflow: item.Value2,
                                FEV: item.Value1
                            };

                            this.PeakFlowReadings.push(reading);
                        }
                        var obj;

                        //SET FIRST CHART DATE
                        if (!this.firstChartDate) {
                            this.firstChartDate = item.ObservationDate;
                        };

                        var date = item.ObservationDate.toISOString();

                        //CHECK FOR EXISTANCE OF DATE
                        if (this.TrendsDates.indexOf(date) < 0) {
                            this.TrendsDates.push(date);
                            obj = {
                                Date: new Date(date),
                                PulseO2: "null",
                                PulseRate: "null",
                                RespiratoryRate: "null",
                                Systolic: "null",
                                Diastolic: "null",
                                Temperature: "null",
                                GCS: "null",
                                BloodSugar: "null",
                                Haematocrit: "null",
                                Ketone: "null"
                            };
                            this.TrendsData.push(obj);
                            this.TrendsDataTable.push(obj);
                        };

                        if (!obj) {
                            this.TrendsData.forEach((item) => {
                                if (item.Date.toISOString() == date) {
                                    obj = item;
                                };
                            });
                        };

                        //ENSURE CORRECT READING(S) ARE MAPPED
                        if (item.Type.Definition) {
                            switch (item.Type.Definition.replace(/\s/g, '')) {
                            case "SPO2":
                                obj["PulseO2"] = item.Value1.toFixed(1);
                                obj["PulseRate"] = item.Value2.toFixed(0);
                                break;
                            case "RespiratoryRate":
                                obj["RespiratoryRate"] = item.Value1.toFixed(0);
                                break;
                            case "BloodPressure":
                                obj["Systolic"] = item.Value1.toFixed(0);
                                obj["Diastolic"] = item.Value2.toFixed(0);
                                break;
                            case "Temperature":
                                obj["Temperature"] = item.Value1.toFixed(1);
                                break;
                            case "GlasgowComaScale":
                                obj["GCS"] = item.Value1.toFixed(0);
                                break;
                            case "BloodGlucoseGen":
                                obj["BloodSugar"] = item.Value1.toFixed(2);
                                break;
                            case "BloodGlucoseHCT":
                                obj["Haematocrit"] = item.Value1.toFixed(0);
                                break;
                            case "BloodGlucoseKetone":
                                obj["Ketone"] = item.Value1.toFixed(1);
                                break;
                            case "PeakFlow":
                                obj["Peakflow"] = item.Value2.toFixed(0);
                                obj["FEV1"] = item.Value1.toFixed(2);
                                break;
                            default:
                                console.log("unknown ", itemType);
                        };
                    };

                    //SET LAST DATE
                    this.lastChartDate = item.ObservationDate;
                });

                //CHECK FOR PEAK FLOW READINGS
                    //if (this.PeakFlowReadings.length == 0) {
                    //    this.ShowPeakFlow = false;
                    //    this.SelectedSeries["PeakFlow"] = false;
                    //};
                setTimeout(() => {
                    this.BuildChart(period);
                        this.ToggleSeries(null);
                        //this.chart.scrollbarX.scrollbarChart.xAxes.getIndex(0).renderer.labels.template.disabled = true;
                        //this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;
                }, 250);
                    console.log("Dates: ", this.TrendsDates);
                    console.log("Data: ", this.TrendsData);
                }
                catch (e) { }
            }, err => {
                console.log(err);
            }
        );
    };

    BuildChart(period: number = 0) {
        if (this.TrendsData != undefined && this.TrendsData != null && this.TrendsData.length != undefined && this.TrendsData.length > 0) {
            this.ngZone.runOutsideAngular(() => {
                var duration = (this.TrendsData[this.TrendsData.length - 1] - this.TrendsData[0].Date) / 24 / 60 / 60 / 1000; // get durration of data in days
                this.chart = this.AmCharts.makeChart("chartdiv", {
                "type": "serial",
                "theme": "light",
                "addClassNames": true,
                "dataProvider": this.TrendsData,
                "valueAxes": [
                    {
                        "id": "y1",
                        "axisAlpha": 0,
                        "position": "left",
                        "minumim": 0,
                        "maximum": 200
                    },
                    {
                        "id": "y2",
                        "axisAlpha": 0,
                        "position": "right",
                        "minumim": 0,
                        "maximum": 40
                    }
                ],
                "graphs": [{
                    "id": "BloodPressure",
                    "balloonText": "<span>Systolic: [[Systolic]] mmHg - Diastolic: [[Diastolic]] mmHg</span>",
                    "lineColor": "#f3c200",
                    "lineThickness": 1,
                    "openField": "Systolic",
                    "closeField": "Diastolic",
                    "title": "Blood Pressure",
                    "type": "candlestick",
                    "valueAxis": "y1",
                    "valueField": "Systolic"
                },
                {
                    "id": "Diastolic",
                    "balloonText": "<span>Diastolic: [[Diastolic]] mmHg</span>",
                    "bullet": "triangleUp",
                    "bulletAlpha": "0",
                    "bulletBorderAlpha": "1",
                    "bulletBorderColor": "#f3c200",
                    "bulletSize": 8,
                    "lineThickness": 0,
                    "type": "line",
                    "title": "Diastolic",
                    "valueAxis": "y1",
                    "valueField": "Diastolic"
                },
                {
                    "id": "Systolic",
                    "balloonText": "<span>Systolic: [[Systolic]] mmHg</span>",
                    "bullet": "triangleDown",
                    "bulletAlpha": "0",
                    "bulletBorderAlpha": "1",
                    "bulletBorderColor": "#f3c200",
                    "bulletSize": 8,
                    "lineThickness": 0,
                    "type": "line",
                    "title": "Systolic",
                    "valueAxis": "y1",
                    "valueField": "Systolic"
                },
                {
                    "id": "PulseRate",
                    "balloonText": "<span>Heart Rate: [[PulseRate]] BPM</span>",
                    "bullet": "circle",
                    "bulletSize": 8,
                    "lineColor": "#000000",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "Pulse Rate",
                    "valueAxis": "y1",
                    "valueField": "PulseRate"
                },
                {
                    "id": "PulseO2",
                    "balloonText": "<span>SpO<sub>2</sub>: [[PulseO2]] %</span>",
                    "bullet": "round",
                    "bulletSize": 8,
                    "lineColor": "#00A6ED",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "SpO2",
                    "valueAxis": "y1",
                    "valueField": "PulseO2"
                },
                {
                    "id": "Temperature",
                    "balloonText": "<span>Temperature: [[Temperature]] C</span>",
                    "bullet": "square",
                    "bulletAlpha": "0",
                    "bulletBorderAlpha": "1",
                    "bulletBorderColor": "#e43a45",
                    "bulletSize": 8,
                    "lineColor": "#e43a45",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "Temperature",
                    "valueAxis": "y2",
                    "valueField": "Temperature"
                },
                {
                    "id": "RespiratoryRate",
                    "balloonText": "<span>Respiratory Rate: [[RespiratoryRate]] BPM</span>",
                    "bullet": "bubble",
                    "bulletAlpha": "0",
                    "bulletBorderAlpha": "1",
                    "bulletBorderColor": "#9A12B3",
                    "bulletSize": 8,
                    "lineColor": "#9A12B3",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "Respiratory Rate",
                    "valueAxis": "y2",
                    "valueField": "RespiratoryRate"
                },
                {
                    "id": "BloodSugar",
                    "balloonText": "<span>Blood Sugar: [[BloodSugar]] mmol/L</span>",
                    "bullet": "triangleUp",
                    "bulletAlpha": "0",
                    "bulletBorderAlpha": "1",
                    "bulletBorderColor": "#0D2C54",
                    "bulletSize": 8,
                    "lineColor": "#0D2C54",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "Blood Sugar",
                    "valueAxis": "y2",
                    "valueField": "BloodSugar"
                },
                {
                    "id": "GCS",
                    "balloonText": "<span>Glasgow Coma Scale: [[GCS]]</span>",
                    "bullet": "round",
                    "bulletSize": 8,
                    "lineColor": "#BF55EC",
                    "lineThickness": 1,
                    "type": "line",
                    "title": "Glasgow Coma Scale",
                    "valueAxis": "y2",
                    "valueField": "GCS"
                }],
                "chartScrollbar": {
                    "graph": "PulseRate",
                    "gridAlpha": 0,
                    "color": "#888888",
                    "scrollbarHeight": 55,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "autoGridCount": true,
                    "selectedGraphFillAlpha": 0,
                    "graphLineAlpha": 0.2,
                    "graphLineColor": "#c2c2c2",
                    "selectedGraphLineColor": "#888888",
                    "selectedGraphLineAlpha": 1,
                    "hideResizeGrips": true
                },
                "chartCursor": {
                        "categoryBalloonDateFormat": "HH:NN:SS - DD-MM-YYYY",
                    "cursorAlpha": 0,
                    "pan": true,
                    "oneBalloonOnly": true,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "valueLineAlpha": 0.5,
                    "fullWidth": true
                },
                "categoryField": "Date",
                "categoryAxis": {
                    "parseDates": true,
                    "equalSpacing": false,
                    "minPeriod": "ss",
                    "twoLineMode": true,
                    "labelFunction": function (valueText, date, categoryAxis) {
                        return period < 0 && duration >= 7 ? date.getUTCDate().toString().padStart(2, '0') + "/" + (date.getUTCMonth() + 1).toString().padStart(2, '0') + "/" + (date.getUTCFullYear()).toString() :
                            date.getUTCDate().toString().padStart(2, '0') + "/"
                            + (date.getUTCMonth() + 1).toString().padStart(2, '0') + " "
                            + date.getUTCHours().toString().padStart(2, '0') + ":"
                            + date.getUTCMinutes().toString().padStart(2, '0');
                    },
                },
                "legend": {
                        "useGraphSettings": true
                }
                });
            });
        };
    };

    ToggleSeries(series) {
        if (series != null)
            this.SelectedSeries[series.Id] = !this.SelectedSeries[series.Id];
        this.ngZone.runOutsideAngular(() => {
            if (series == null || series.Id != "PeakFlow") {
                this.AmCharts.updateChart(this.chart, () => {
                    this.chart.events.rendered = [];
                    this.chart.dataProvider = this.filterDataSeries(this.TrendsData);
                });
            } else {
                this.ShowPeakFlow = this.ShowPeakFlow ? false : true;
            };
        });
    };

    filterDataSeries(data: any[]): any[] {
        var selectedSeries = this.SelectedSeries;
        function filterSeries(d) {
            var _s = { Date: d["Date"] };
            for (var k in selectedSeries) {
                if (selectedSeries[k]) {
                    switch (k) {
                        case "BloodPressure":
                            _s["Systolic"] = d["Systolic"];
                            _s["Diastolic"] = d["Diastolic"];
                            break;
                        default:
                            _s[k] = d[k];
                            break;
                    }
                }
            }
            return _s;
        }
        var _data = data.map(filterSeries);
        return _data;
    }

    SelectPeriod(item) {
        this.Period = item.Period;
        this.Offset = 0;
        this.SelectedTime = item.Title;
        this.GetChartData(this.Period);
    };
    Forward() {
        if (this.Offset <= 0)
            return this._notification.alert("Offset can't be less than 0.");

        this.Offset = this.Offset - this.Period;
        this.GetChartData(this.Period, this.Offset);
    }
    Backward() {
        this.Offset = this.Offset + this.Period;
        this.GetChartData(this.Period, this.Offset);
    }

    getDeviceHeaders(devices) {
        var result = [];
        if (devices && devices.length) {
            for (var i = 0; i < devices.length; i++) {
                var device = devices[i];
                switch (device) {
                    case "SPO2":
                        result.push("PulseO2");
                        result.push("PulseRate");
                        break;
                    case "BloodPressure":
                        result.push("Systolic");
                        result.push("Diastolic");
                        break;
                    case "PeakFlow":
                        result.push("Peakflow");
                        result.push("FEV1");
                        break;
                    case "BloodGlucose Gen":
                        result.push("BloodSugar");
                        break;
                    case "BloodGlucose HCT":
                        result.push("Haematocrit");
                        break;
                    case "BloodGlucose Ketone":
                        result.push("Ketone");
                        break;
                    case "GlasgowComaScale":
                        result.push("GCS");
                        break;
                    default:
                        result.push(device);
                        break;
                }
            }
        }
        return result;
    };

    getNiceNameFromDeviceName(deviceName) {
        switch (deviceName) {
            case "PulseO2":
                return "SpO<sub>2</sub>";
            default:
                return deviceName;
        }
    }

    viewReadings() {
        this.devices = [];
        this.observaions.forEach((o) => {
            if (o.Type && o.Type.Value && this.devices.indexOf(o.Type.Value) == -1)
                this.devices.push(o.Type.Value);
        });

        this.ReadingsModal.show();
    };
}



// WEBPACK FOOTER //
// ./src/app/case/details/trends/case-details-trends.component.ts